<span
  class="fz-currency"
  [class]="{ credit: highlightCredit && value && value > 0 }"
>
  <span class="value">{{ dollar }}</span>
</span>
